import useSWR from "swr";
import { getData } from "../backend";
import { WorkflowAutomationItem } from "../interfaces";

export default function useReviewItems(workflowId?: string) {
  return useSWR<Array<WorkflowAutomationItem>>(workflowId ? `/workflows/${workflowId}/review-items/` : null, getData);
}